/**
 * Listing API endpoint schemas
 *
 * Export all Zod schemas and types for listing-related API endpoints
 */

// Get listing
export {
  GetListingParamSchema,
  GetListingDataSchema,
  GetListingResponseSchema,
  type GetListingParam,
  type GetListingData,
  type GetListingResponse,
} from './get';

// Report listing
export {
  ReportListingRequestSchema,
  ReportListingResponseSchema,
  type ReportListingRequest,
  type ReportListingResponse,
} from './report';

// Bulk archive
export {
  BulkArchiveRequestSchema,
  BulkArchiveResponseSchema,
  type BulkArchiveRequest,
  type BulkArchiveResponse,
} from './bulk-archive';

// Bulk feature
export {
  BulkFeatureRequestSchema,
  BulkFeatureResponseSchema,
  type BulkFeatureRequest,
  type BulkFeatureResponse,
} from './bulk-feature';

// Bulk auto-tag
export {
  BulkAutoTagRequestSchema,
  BulkAutoTagResponseSchema,
  type BulkAutoTagRequest,
  type BulkAutoTagResponse,
} from './bulk-auto-tag';

// Bulk feature for partner
export {
  BulkFeatureForPartnerRequestSchema,
  BulkFeatureForPartnerResponseSchema,
  type BulkFeatureForPartnerRequest,
  type BulkFeatureForPartnerResponse,
} from './bulk-feature-for-partner';

// Inbox
export {
  InboxQuerySchema,
  InboxResponseSchema,
  type InboxQuery,
  type InboxResponse,
} from './inbox';

// Create listing
export {
  CreateListingRequestSchema,
  CreateListingResponseSchema,
  PresignedUrlSchema,
  CreateListingSuccessSchema,
  type CreateListingRequest,
  type CreateListingResponse,
  type PresignedUrl,
} from './create';

// Feature listing
export {
  FeatureListingParamSchema,
  FeatureListingResponseSchema,
  FeatureListingDbSchema,
  type FeatureListingParam,
  type FeatureListingResponse,
  type FeatureListingDb,
} from './feature';

// Feature for partner
export {
  FeatureForPartnerParamSchema,
  FeatureForPartnerRequestSchema,
  FeatureForPartnerResponseSchema,
  type FeatureForPartnerParam,
  type FeatureForPartnerRequest,
  type FeatureForPartnerResponse,
} from './feature-for-partner';

// Get status
export {
  GetStatusParamSchema,
  GetStatusResponseSchema,
  type GetStatusParam,
  type GetStatusResponse,
} from './status';

// Confirm photos
export {
  ConfirmPhotosParamSchema,
  ConfirmPhotosResponseSchema,
  type ConfirmPhotosParam,
  type ConfirmPhotosResponse,
} from './confirm-photos';

// Archive listing
export {
  ArchiveListingParamSchema,
  ArchiveListingSuccessResponseSchema,
  ArchiveListingResponseSchema,
  type ArchiveListingParam,
  type ArchiveListingSuccessResponse,
  type ArchiveListingResponse,
} from './archive';

// Delete listing
export {
  DeleteListingParamSchema,
  DeleteListingResponseSchema,
  type DeleteListingParam,
  type DeleteListingResponse,
} from './delete';

// Mark sold
export {
  MarkSoldParamSchema,
  MarkSoldSuccessResponseSchema,
  MarkSoldResponseSchema,
  type MarkSoldParam,
  type MarkSoldSuccessResponse,
  type MarkSoldResponse,
} from './mark-sold';

// Edit listing
export {
  EditListingRequestSchema,
  EditListingResponseSchema,
  PresignedUrlItemSchema,
  EditedListingDataSchema,
  EditListingSuccessSchema,
  type EditListingRequest,
  type EditListingResponse,
  type PresignedUrlItem,
  type EditedListingData,
} from './edit';

// Inbox detail schemas (extended listing data for admin inbox)
export {
  PartnerFeaturedSchema,
  InboxListingDetailSchema,
  InboxListingsResponseSchema,
  InboxSortOptionSchema,
  InboxFilterStateSchema,
  type PartnerFeatured,
  type InboxListingDetail,
  type InboxListingsResponse,
  type InboxSortOption,
  type InboxFilterState,
} from './inbox-detail';

// Admin edit listing
export {
  AdminEditRequestSchema,
  AdminEditListingSchema,
  AdminEditSuccessSchema,
  AdminEditErrorSchema,
  AdminEditResponseSchema,
  type AdminEditRequest,
  type AdminEditListing,
  type AdminEditSuccess,
  type AdminEditError,
  type AdminEditResponse,
} from './admin-edit';

// Transfer listing images
export {
  TransferRequestSchema,
  TransferSuccessSchema,
  TransferErrorSchema,
  TransferResponseSchema,
  type TransferRequest,
  type TransferSuccess,
  type TransferError,
  type TransferResponse,
} from './transfer';

// Listing metadata
export {
  ListingMetadataRequestSchema,
  ListingMetadataResponseSchema,
  ListingMetadataErrorResponseSchema,
  MetadataPhotoSchema,
  type ListingMetadataRequest,
  type ListingMetadataResponse,
  type ListingMetadataErrorResponse,
  type MetadataPhoto,
} from './metadata';

// Listing remote URL
export {
  ListingRemoteUrlRequestSchema,
  ListingRemoteUrlResponseSchema,
  ListingRemoteUrlErrorResponseSchema,
  type ListingRemoteUrlRequest,
  type ListingRemoteUrlResponse,
  type ListingRemoteUrlErrorResponse,
} from './remote-url';
